var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFavourites = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 160,
  height: 161,
  viewBox: "0 0 160 161",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28.712 28.343c-1.219.973-2.438 2.27-2.926 4.053-.853 3.404 1.585 6.808 3.901 8.591 2.439 1.783 5.243 3.08 6.462 6.322 1.585 4.214-.731 9.564-3.901 11.833-3.17 2.27-6.828 2.432-10.363 3.404-4.024.973-7.925 2.756-11.46 5.512-4.755 3.566-9.266 9.725-8.291 16.858 1.097 7.78 7.925 11.185 13.655 13.13 33.893 11.509 68.152 22.207 103.021 24.153 7.315.486 14.752.324 21.823-2.594 6.95-2.918 13.533-9.24 16.215-18.317 1.585-5.35 1.707-11.833-.731-16.696-2.804-5.512-8.169-7.457-12.68-10.213-5.852-3.566-11.46-9.888-12.07-18.479-.609-7.78 3.048-16.372 0-23.018-1.706-3.89-5.12-5.673-8.29-6.97-13.777-5.836-28.529-6.646-42.915-6.484-4.511 0-9.022.324-13.411.648-5.852.324-11.826 0-17.679.486-6.827.325-14.142 2.594-20.36 7.781Z",
  fill: "url(#a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M85.48 141.386H2l25.999-18.977L112 129.526l-26.52 11.86Z",
  fill: "url(#b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m70.887 102.287-50.495 14.274c-1.678.42.14 1.679 0 0L12 58.765 79 48.41l-8.113 53.878Z",
  fill: "url(#c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M127.466 122.402c-.697 1.126 1.255.422 0 0Z",
  fill: "url(#d)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m106.553 57.54 15.058 5.487L158 76.253l-30.534 46.008L71 101.579l8.087-54.17 27.466 10.13Zm13.385 15.899 4.879 1.829c1.255.422 2.649-.14 3.068-1.407.557-1.266-.14-2.673-1.395-3.096l-5.019-1.829-14.5-5.346c-1.255-.563-2.649.14-3.067 1.407-.558 1.266.139 2.673 1.394 3.095l14.64 5.347Z",
  fill: "url(#e)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m128.874 122.578-41.808 17.831-3.066-.276 31.495-44.786L158 76.409l-27.872 45.201c-.279.415-.697.83-1.254.968Z",
  fill: "url(#f)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M39 72.41s12.26-6.934 11.996-11.067c-.264-4.134-5.405-6.934-5.405-6.934L39 72.41Z",
  fill: "url(#g)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M37.942 71.41S18.757 66.086 22.479 55.44c2.72-8.2 12.17-3.453 12.743-.431",
  fill: "#008C78"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M37.943 71.41s16.321-11.365 9.306-20.285c-5.298-6.76-12.6.864-12.027 3.885",
  fill: "#0AC39B"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M142.44 62.928s-2.51-12.455 4.463-13.445c5.439-.85 5.439 5.944 3.905 7.076",
  fill: "#008C78"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M142.439 62.928s11.158 5.944 14.086-.566c2.232-4.954-4.044-6.935-5.718-5.803",
  fill: "#0AC39B"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "m120.203 73.536-14.755-5.396c-1.248-.431-1.708-1.97-1.154-3.263.417-1.292 1.68-1.79 2.928-1.215l14.506 5.369c.277-2.011.324-3.884.185-5.895l-15.05-5.5L76 82.398c-.138-.144 38.794 1.478 44.203-8.862Z",
  fill: "#000"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M75.972 82.41S42.026 49.37 62.646 31.83c15.57-13.325 29.739 7.07 27.073 14.004",
  fill: "#008C78"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M75.973 82.41s47.974-4.08 43.766-30.321c-3.086-19.988-27.494-13.053-30.02-6.119",
  fill: "#0AC39B"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.872 115.299 12 58.765l103.495 36.582-27.637 44.807c-.696 1.099-2.088 1.511-3.34 1.099L18.68 117.634c-.974-.412-1.67-1.236-1.81-2.335Zm34.936-30.073 19.487 7.003c1.252.412 2.644-.137 3.062-1.373.556-1.236-.14-2.61-1.392-3.021l-19.487-7.003c-1.252-.55-2.644.137-3.062 1.373-.556 1.236.14 2.609 1.392 3.02Z",
  fill: "url(#h)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 2.148,
  y1: 122.201,
  x2: 158.278,
  y2: 122.201,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#E3F4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9DDBFC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: -77.973,
  y1: 127.745,
  x2: -74.339,
  y2: 167.085,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.002,
  stopColor: "#fff",
  stopOpacity: 0.01
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BEBFC0",
  stopOpacity: 0.7
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 78.14,
  y1: 48,
  x2: 9.69,
  y2: 47.033,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#909193"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.628,
  stopColor: "#E5E6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#909193"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 35.094,
  y1: 103.528,
  x2: 103.223,
  y2: 158.469,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.127,
  stopColor: "#7B7C7F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.997,
  stopColor: "#393839"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: -26.481,
  y1: 158.196,
  x2: 199.006,
  y2: 264.886,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.127,
  stopColor: "#7B7C7F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.997,
  stopColor: "#393839"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 101.214,
  y1: 110.227,
  x2: 120.473,
  y2: 131.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.628,
  stopColor: "#E5E6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D8D9DA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 41.272,
  y1: 69.146,
  x2: 49.166,
  y2: 70.378,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.127,
  stopColor: "#7B7C7F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.997,
  stopColor: "#393839"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: -33.324,
  y1: 97.055,
  x2: 35.294,
  y2: 183.716,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5E6E6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.841,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D8D9DA"
})))));
export { SvgFavourites as ReactComponent };
export default "data:image/svg+xml,%3csvg width='160' height='161' viewBox='0 0 160 161' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M28.712 28.343c-1.219.973-2.438 2.27-2.926 4.053-.853 3.404 1.585 6.808 3.901 8.591 2.439 1.783 5.243 3.08 6.462 6.322 1.585 4.214-.731 9.564-3.901 11.833-3.17 2.27-6.828 2.432-10.363 3.404-4.024.973-7.925 2.756-11.46 5.512-4.755 3.566-9.266 9.725-8.291 16.858 1.097 7.78 7.925 11.185 13.655 13.13 33.893 11.509 68.152 22.207 103.021 24.153 7.315.486 14.752.324 21.823-2.594 6.95-2.918 13.533-9.24 16.215-18.317 1.585-5.35 1.707-11.833-.731-16.696-2.804-5.512-8.169-7.457-12.68-10.213-5.852-3.566-11.46-9.888-12.07-18.479-.609-7.78 3.048-16.372 0-23.018-1.706-3.89-5.12-5.673-8.29-6.97-13.777-5.836-28.529-6.646-42.915-6.484-4.511 0-9.022.324-13.411.648-5.852.324-11.826 0-17.679.486-6.827.325-14.142 2.594-20.36 7.781Z' fill='url(%23a)'/%3e%3cpath d='M85.48 141.386H2l25.999-18.977L112 129.526l-26.52 11.86Z' fill='url(%23b)'/%3e%3cpath d='m70.887 102.287-50.495 14.274c-1.678.42.14 1.679 0 0L12 58.765 79 48.41l-8.113 53.878Z' fill='url(%23c)'/%3e%3cpath d='M127.466 122.402c-.697 1.126 1.255.422 0 0Z' fill='url(%23d)'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='m106.553 57.54 15.058 5.487L158 76.253l-30.534 46.008L71 101.579l8.087-54.17 27.466 10.13Zm13.385 15.899 4.879 1.829c1.255.422 2.649-.14 3.068-1.407.557-1.266-.14-2.673-1.395-3.096l-5.019-1.829-14.5-5.346c-1.255-.563-2.649.14-3.067 1.407-.558 1.266.139 2.673 1.394 3.095l14.64 5.347Z' fill='url(%23e)'/%3e%3cpath d='m128.874 122.578-41.808 17.831-3.066-.276 31.495-44.786L158 76.409l-27.872 45.201c-.279.415-.697.83-1.254.968Z' fill='url(%23f)'/%3e%3cpath opacity='.2' d='M39 72.41s12.26-6.934 11.996-11.067c-.264-4.134-5.405-6.934-5.405-6.934L39 72.41Z' fill='url(%23g)'/%3e%3cpath d='M37.942 71.41S18.757 66.086 22.479 55.44c2.72-8.2 12.17-3.453 12.743-.431' fill='%23008C78'/%3e%3cpath d='M37.943 71.41s16.321-11.365 9.306-20.285c-5.298-6.76-12.6.864-12.027 3.885' fill='%230AC39B'/%3e%3cpath d='M142.44 62.928s-2.51-12.455 4.463-13.445c5.439-.85 5.439 5.944 3.905 7.076' fill='%23008C78'/%3e%3cpath d='M142.439 62.928s11.158 5.944 14.086-.566c2.232-4.954-4.044-6.935-5.718-5.803' fill='%230AC39B'/%3e%3cpath opacity='.4' d='m120.203 73.536-14.755-5.396c-1.248-.431-1.708-1.97-1.154-3.263.417-1.292 1.68-1.79 2.928-1.215l14.506 5.369c.277-2.011.324-3.884.185-5.895l-15.05-5.5L76 82.398c-.138-.144 38.794 1.478 44.203-8.862Z' fill='%23000'/%3e%3cpath d='M75.972 82.41S42.026 49.37 62.646 31.83c15.57-13.325 29.739 7.07 27.073 14.004' fill='%23008C78'/%3e%3cpath d='M75.973 82.41s47.974-4.08 43.766-30.321c-3.086-19.988-27.494-13.053-30.02-6.119' fill='%230AC39B'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M16.872 115.299 12 58.765l103.495 36.582-27.637 44.807c-.696 1.099-2.088 1.511-3.34 1.099L18.68 117.634c-.974-.412-1.67-1.236-1.81-2.335Zm34.936-30.073 19.487 7.003c1.252.412 2.644-.137 3.062-1.373.556-1.236-.14-2.61-1.392-3.021l-19.487-7.003c-1.252-.55-2.644.137-3.062 1.373-.556 1.236.14 2.609 1.392 3.02Z' fill='url(%23h)'/%3e%3cdefs%3e%3clinearGradient id='a' x1='2.148' y1='122.201' x2='158.278' y2='122.201' gradientUnits='userSpaceOnUse'%3e%3cstop offset='0' stop-color='%23E3F4FF'/%3e%3cstop offset='1' stop-color='%239DDBFC'/%3e%3c/linearGradient%3e%3clinearGradient id='b' x1='-77.973' y1='127.745' x2='-74.339' y2='167.085' gradientUnits='userSpaceOnUse'%3e%3cstop offset='.002' stop-color='%23fff' stop-opacity='.01'/%3e%3cstop offset='1' stop-color='%23BEBFC0' stop-opacity='.7'/%3e%3c/linearGradient%3e%3clinearGradient id='c' x1='78.14' y1='48' x2='9.69' y2='47.033' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23909193'/%3e%3cstop offset='.628' stop-color='%23E5E6E6'/%3e%3cstop offset='1' stop-color='%23909193'/%3e%3c/linearGradient%3e%3clinearGradient id='d' x1='35.094' y1='103.528' x2='103.223' y2='158.469' gradientUnits='userSpaceOnUse'%3e%3cstop offset='.127' stop-color='%237B7C7F'/%3e%3cstop offset='.997' stop-color='%23393839'/%3e%3c/linearGradient%3e%3clinearGradient id='e' x1='-26.481' y1='158.196' x2='199.006' y2='264.886' gradientUnits='userSpaceOnUse'%3e%3cstop offset='.127' stop-color='%237B7C7F'/%3e%3cstop offset='.997' stop-color='%23393839'/%3e%3c/linearGradient%3e%3clinearGradient id='f' x1='101.214' y1='110.227' x2='120.473' y2='131.01' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23fff'/%3e%3cstop offset='.628' stop-color='%23E5E6E6'/%3e%3cstop offset='1' stop-color='%23D8D9DA'/%3e%3c/linearGradient%3e%3clinearGradient id='g' x1='41.272' y1='69.146' x2='49.166' y2='70.378' gradientUnits='userSpaceOnUse'%3e%3cstop offset='.127' stop-color='%237B7C7F'/%3e%3cstop offset='.997' stop-color='%23393839'/%3e%3c/linearGradient%3e%3clinearGradient id='h' x1='-33.324' y1='97.055' x2='35.294' y2='183.716' gradientUnits='userSpaceOnUse'%3e%3cstop stop-color='%23E5E6E6'/%3e%3cstop offset='.841' stop-color='%23fff'/%3e%3cstop offset='1' stop-color='%23D8D9DA'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e";